import { render } from "./IncomeLossChart.vue?vue&type=template&id=6bd716ae"
import script from "./IncomeLossChart.vue?vue&type=script&lang=js"
export * from "./IncomeLossChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/p878kMc7/0/softbot/pplotto/pplotto-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__